import { render } from "./CreateEditSite.vue?vue&type=template&id=5b997460"
import script from "./CreateEditSite.vue?vue&type=script&lang=ts"
export * from "./CreateEditSite.vue?vue&type=script&lang=ts"
script.render = render

export default script